import { render, staticRenderFns } from "./MaterialSupplierList.vue?vue&type=template&id=6a6813ac&scoped=true"
import script from "./MaterialSupplierList.vue?vue&type=script&lang=js"
export * from "./MaterialSupplierList.vue?vue&type=script&lang=js"
import style0 from "./MaterialSupplierList.vue?vue&type=style&index=0&id=6a6813ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6813ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a6813ac')) {
      api.createRecord('6a6813ac', component.options)
    } else {
      api.reload('6a6813ac', component.options)
    }
    module.hot.accept("./MaterialSupplierList.vue?vue&type=template&id=6a6813ac&scoped=true", function () {
      api.rerender('6a6813ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/material/MaterialSupplierList.vue"
export default component.exports